import { useAppSelector } from 'shared/store/store'
import { getMessageRecipients } from 'shared/store/sendMessage/recipients/selectors'
import { FilterTypeEnum } from '../models/Recipients'
import { useTerminology } from 'shared/hooks/useTerminology'

const useGetTerminologyFilterTypes = () => {
  const { Eiere, Leietakere } = useTerminology()
  const { meters, objects, openState } = useAppSelector(getMessageRecipients)

  const list = [
    {
      id: FilterTypeEnum.Owners,
      displayText: Eiere,
    },
    {
      id: FilterTypeEnum.Tenants,
      displayText: Leietakere,
    },
    {
      id: FilterTypeEnum.Cohabitant,
      displayText: 'Medboere',
    },
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.BoardMembers,
            displayText: 'Styre og komiteer',
          },
        ]
      : []),
    {
      id: FilterTypeEnum.Objects,
      displayText: 'Annet',
    },
    {
      id: FilterTypeEnum.Meters,
      displayText: 'Målere',
    },
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.BoardContacts,
            displayText: 'Styrets kontakter',
          },
        ]
      : []),
    ...(openState !== 'Message'
      ? [
          {
            id: FilterTypeEnum.OtherContacts,
            displayText: 'Andre kontakter',
          },
        ]
      : []),
  ]

  return list.filter((item) => {
    // Filter out objects and meters if there are no objects or meters
    if (item.id === FilterTypeEnum.Objects && !objects.length) return false
    if (item.id === FilterTypeEnum.Meters && !meters.length) return false

    return true
  })
}

export default useGetTerminologyFilterTypes
